import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { LegalsHeader } from '../legals-header/legals-header';

@Component({
  selector: 'app-privacy-policy',
  imports: [LegalsHeader, RouterLink],
  templateUrl: './privacy-policy.html',
})
export class PrivacyPolicy {}
